import React, { useEffect, useState } from "react";
import "./stats.css";
import { MdWorkOutline } from "react-icons/md";
import { FiExternalLink } from "react-icons/fi";
import { FaHackerrank } from "react-icons/fa";
import { BiGitCommit, BiGitPullRequest } from "react-icons/bi";
import { BsStar } from "react-icons/bs";
import { IoLogoGoogle } from "react-icons/io";
import {
  SiEthereum,
  SiHiveBlockchain,
  SiOracle,
  SiIbm,
  SiTcs,
  SiCoursera,
} from "react-icons/si";
import { RiGitRepositoryCommitsLine } from "react-icons/ri";
import { VscAzure } from "react-icons/vsc";
import axios from "axios";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { Octokit } from "octokit";
import { useCookies } from "react-cookie";

const {
  REACT_APP_GITHUB_PAT,
  REACT_APP_USERNAME,
  REACT_APP_API_KEY,
  REACT_APP_PORTFOLIO_API_HOSTNAME,
  REACT_APP_PORTFOLIO_API_LEETCODE_ENDPOINT,
  REACT_APP_PORTFOLIO_API_GITHUB_ENDPOINT,
} = process.env;

const octokit = new Octokit({
  auth: REACT_APP_GITHUB_PAT,
});
const LEETCODE_API_ENDPOINT = `${REACT_APP_PORTFOLIO_API_HOSTNAME}${REACT_APP_PORTFOLIO_API_LEETCODE_ENDPOINT}${REACT_APP_USERNAME}`;
const GITHUB_API_ENDPOINT = `${REACT_APP_PORTFOLIO_API_HOSTNAME}${REACT_APP_PORTFOLIO_API_GITHUB_ENDPOINT}`;
const GEOLOCATION_API_ENDPOINT = `https://ipgeolocation.abstractapi.com/v1/?api_key=${REACT_APP_API_KEY}`;

let cookieExpiry = new Date();
cookieExpiry.setDate(cookieExpiry.getDate() + 30 * 24 * 60 * 60);

const fetchLeetcodeProfile = async () => {
  console.log(`Fetching User Stats using LeetCode API...`);
  const res = await axios.get(LEETCODE_API_ENDPOINT, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  // const res = {};
  console.log("Leetcode API call status: Success!");
  console.log(res);
  return res;
};

const fetchGeolocation = async () => {
  const res = await axios.get(GEOLOCATION_API_ENDPOINT);
  console.log(res.data);
};

const fetchGitHubProfile = async () => {
  let result = {
    totalRepos: 0,
    totalCommits: 0,
    totalStars: 0,
    totalPRs: 0,
  };

  console.log("Fetching User Data using GitHub API...");

  const res = await axios.get(GITHUB_API_ENDPOINT, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  console.log(res.data);

  result.totalRepos = res?.data?.stats.repos;
  result.totalCommits = res?.data?.stats.commits;
  result.totalStars = res?.data?.stats.stars;
  result.totalPRs = res?.data?.stats.pulls;

  console.log("GitHub API call status: Success!");

  return result;
};

const Stats = () => {
  const [cookies, setCookies] = useCookies({
    totalRepos: 0,
    totalCommits: 0,
    totalPRs: 0,
    totalStars: 0,
    leetcodeCookie: {},
  });
  const [leetcodeStats, setLeetcodeStats] = useState({});
  const [gitHubStats, setGitHubStats] = useState({});

  useEffect(() => {
    fetchLeetcodeProfile().then((res) => {
      // console.log(cookies.leetcodeCookie);
      setLeetcodeStats(res.data);
      // console.log("COOKIE", cookies?.leetcodeCookie);
      if (res?.status === 200) {
        setCookies("leetcodeCookie", res.data, {
          path: "/",
          expires: cookieExpiry,
          priority: "High",
        });
      }
    });

    fetchGitHubProfile().then((res) => {
      // console.log(res)
      setGitHubStats(res);
      const { totalRepos, totalCommits, totalPRs, totalStars } = res;
      setCookies("totalRepos", totalRepos, {
        path: "/",
        expires: cookieExpiry,
        priority: "High",
      });
      setCookies("totalCommits", totalCommits, {
        path: "/",
        expires: cookieExpiry,
        priority: "High",
      });
      setCookies("totalPRs", totalPRs, {
        path: "/",
        expires: cookieExpiry,
        priority: "High",
      });
      setCookies("totalStars", totalStars, {
        path: "/",
        expires: cookieExpiry,
        priority: "High",
      });
    });

    fetchGeolocation();
  }, []);

  return (
    <section id="stats">
      <h5>Platforms I use</h5>
      <h2>My Stats</h2>

      <div className="container stats__container">
        <article className="stat">
          <div className="stat__head">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/1/19/LeetCode_logo_black.png"
              alt="Leetcode"
            />
            <h3>Leetcode Stats</h3>
          </div>

          <div className="stat_list">
            <CircularProgressbar
              className="stat__circprogress"
              value={
                leetcodeStats?.totalSolved ??
                cookies?.leetcodeCookie?.totalSolved ??
                0
              }
              maxValue={
                leetcodeStats?.totalQuestions ??
                cookies?.leetcodeCookie?.totalQuestions ??
                0
              }
              strokeWidth={5}
              text={`${(
                ((leetcodeStats?.totalSolved ??
                  cookies?.leetcodeCookie?.totalSolved ??
                  0) *
                  100) /
                (leetcodeStats?.totalQuestions ??
                  cookies?.leetcodeCookie?.totalQuestions ??
                  1)
              ).toFixed(2)} %`}
              styles={buildStyles({
                pathColor: `rgb(121, 255, 244)`,
                trailColor: `rgb(85, 85, 85)`,
                textSize: `19px`,
                textColor: `#4db5ff`,
              })}
            />
            <span className="stat__desc">
              <span>
                <span className="stat__desc-sp">Solved&nbsp;</span>
                <span className="stat__key-total">
                  {" "}
                  {leetcodeStats?.totalSolved ??
                    cookies?.leetcodeCookie?.totalSolved ??
                    0}
                </span>
              </span>
              <span>
                <span className="stat__desc-sp">Rank&nbsp;</span>
                <span className="stat__key-rank">
                  {leetcodeStats?.ranking ??
                    cookies?.leetcodeCookie?.ranking ??
                    0}
                </span>
              </span>
            </span>
          </div>

          <div className="stat__list">
            <span className="stat__key stat__key-easy">Easy</span>
            <span className="stat_val">
              {leetcodeStats?.easySolved ??
                cookies?.leetcodeCookie?.easySolved ??
                0}{" "}
              /{" "}
              {leetcodeStats?.totalEasy ??
                cookies?.leetcodeCookie?.totalEasy ??
                0}
            </span>
            <progress
              className="stat__progress stat__progress-easy"
              value={
                leetcodeStats?.easySolved ??
                cookies?.leetcodeCookie?.easySolved ??
                0
              }
              max={
                leetcodeStats?.totalEasy ??
                cookies?.leetcodeCookie?.totalEasy ??
                0
              }
            />
          </div>
          <div className="stat__list">
            <span className="stat__key stat__key-medi">Medium</span>
            <span className="stat_val">
              {leetcodeStats?.mediumSolved ??
                cookies.leetcodeCookie?.mediumSolved ??
                0}{" "}
              /{" "}
              {leetcodeStats?.totalMedium ??
                cookies?.leetcodeCookie?.totalMedium ??
                0}
            </span>
            <progress
              className="stat__progress stat__progress-medi"
              value={
                leetcodeStats?.mediumSolved ??
                cookies.leetcodeCookie?.mediumSolved ??
                0
              }
              max={
                leetcodeStats?.totalMedium ??
                cookies?.leetcodeCookie?.totalMedium ??
                0
              }
            />
          </div>
          <div className="stat__list">
            <span className="stat__key stat__key-hard">Hard</span>
            <span className="stat_val">
              {leetcodeStats?.hardSolved ??
                cookies?.leetcodeCookie?.hardSolved ??
                0}{" "}
              /{" "}
              {leetcodeStats?.totalHard ??
                cookies?.leetcodeCookie?.totalHard ??
                0}
            </span>
            <progress
              className="stat__progress stat__progress-hard"
              value={
                leetcodeStats?.hardSolved ??
                cookies?.leetcodeCookie?.hardSolved ??
                0
              }
              max={
                leetcodeStats?.totalHard ??
                cookies?.leetcodeCookie?.totalHard ??
                0
              }
            />
          </div>
        </article>
        {/* END OF UI/UX */}

        <article className="stat">
          <div className="stat__head">
            <img
              src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg"
              alt="GitHub"
            />
            <h3>GitHub Stats</h3>
          </div>

          <ul className="">
            <li className="stat__list-git">
              <RiGitRepositoryCommitsLine className="stat__list-icon repo-icon" />
              <p>
                Total Repositories:{" "}
                <span className="stat__key repos">
                  {gitHubStats?.totalRepos ?? cookies?.totalRepos ?? 0}
                </span>
              </p>
            </li>
            <li className="stat__list-git">
              <BiGitCommit className="stat__list-icon commit-icon" />
              <p>
                Total Commits:{" "}
                <span className="stat__key commits">
                  {gitHubStats?.totalCommits ?? cookies?.totalCommits ?? 0}
                </span>
              </p>
            </li>
            <li className="stat__list-git">
              <BiGitPullRequest className="stat__list-icon pr-icon" />
              <p>
                Total Pull Requests:{" "}
                <span className="stat__key prs">
                  {gitHubStats?.totalPRs ?? cookies?.totalPRs ?? 0}
                </span>
              </p>
            </li>
            <li className="stat__list-git">
              <BsStar className="stat__list-icon star-icon" />
              <p>
                Total Stars:{" "}
                <span className="stat__key stars">
                  {gitHubStats?.totalStars ?? cookies?.totalStars ?? 0}
                </span>
              </p>
            </li>
          </ul>
          <img
            className="vercel__card"
            src="https://camo.githubusercontent.com/dadd171e0809c787651df6848c7b4ac46611e04f257094f81d063ea0ca0963d2/687474703a2f2f6769746875622d70726f66696c652d73756d6d6172792d63617264732e76657263656c2e6170702f6170692f63617264732f7265706f732d7065722d6c616e67756167653f757365726e616d653d6d6f6f6e6d616e333639267468656d653d6d69646e696768745f707572706c65"
            alt="GitHub Stats Card"
          />
        </article>
        {/* END OF WEB D */}

        <article className="stat">
          <div className="stat__head">
            <img
              src="https://cdn-icons-png.flaticon.com/512/2258/2258567.png"
              alt="Certificates"
            />
            <h3>Certificates</h3>
          </div>

          <ul className="stat__list">
            <li>
              <SiOracle className="stat__list-icon-certificate oracle" />
              <a
                href="https://drive.google.com/file/d/1s3i9218hfue91ELClDyhXQqNdj2c7YNG/view?usp=sharing"
                target="_blank"
              >
                OCI - Gen AI Professional <FiExternalLink />
              </a>
            </li>
            <li>
              <SiTcs className="stat__list-icon-certificate tcs" />
              <a
                href="https://drive.google.com/file/d/1mVyzjpfoyj5GLRr0HvWYuOcyJW6e8-6V/view?usp=sharing"
                target="_blank"
              >
                TCS AI Friday <FiExternalLink />
              </a>
            </li>
            <li>
              <SiCoursera className="stat__list-icon-certificate coursera" />
              <a
                href="https://drive.google.com/file/d/1wHW1TsoHb5if_-0FhLxyj6m0ZYOEDkWz/view?usp=sharing"
                target="_blank"
              >
                Coursera + DeepLearningAI: RAG <FiExternalLink />
              </a>
            </li>
            <li>
              <SiIbm className="stat__list-icon-certificate ibm" />
              <a
                href="https://coursera.org/share/9289ae0ffdf337597952f42d48f48924"
                target="_blank"
              >
                IBM, Gen AI for SDE <FiExternalLink />
              </a>
            </li>
            <li>
              <VscAzure className="stat__list-icon-certificate azure" />
              <a
                href="https://drive.google.com/file/d/1zz9vJ3r2AzDdWC6fPUIjqWRv_RYGvjyE/view?usp=sharing"
                target="_blank"
              >
                Microsoft AZ-900 Certification <FiExternalLink />
              </a>
            </li>
            <li>
              <MdWorkOutline className="stat__list-icon-certificate intern" />
              <a
                href="https://drive.google.com/file/d/1BPcUwBleZGfb2CM5jZ7NM4MyX3EQo4Xg/view?usp=sharing"
                target="_blank"
              >
                Internship, W3 Dev Private Limited <FiExternalLink />
              </a>
            </li>
            <li>
              <SiHiveBlockchain className="stat__list-icon-certificate block" />
              <a
                href="https://drive.google.com/file/d/1vssY0bkRWdwDYN4zfTTFFGO5UIwgJwB8/view?usp=share_link"
                target="_blank"
              >
                Blockchain Course, Udemy <FiExternalLink />
              </a>
            </li>
            <li>
              <IoLogoGoogle className="stat__list-icon-certificate goog" />
              <a
                href="https://drive.google.com/file/d/1tnS2bd_6f_PDUB8J4xePtsIpWVTIYjRN/view?usp=sharing"
                target="_blank"
              >
                Google, Crash Course on Python <FiExternalLink />
              </a>
            </li>
            {/* <li>
              <IoLogoGoogle className="stat__list-icon-certificate goog" />
              <a
                href="https://drive.google.com/file/d/1es2hoYVWtfhLeZi0x6pYm9B4xHT2d2aL/view?usp=share_link"
                target="_blank"
              >
                Google, Python Scripting and OS <FiExternalLink />
              </a>
            </li>
            <li>
              <SiEthereum className="stat__list-icon-certificate eth" />
              <a
                href="https://drive.google.com/file/d/1BsXQvH0jC0cmdQ-e9Bf0ltsnhZPIDFL7/view?usp=share_link"
                target="_blank"
              >
                Ethereum and Solidity, Udemy <FiExternalLink />
              </a>
            </li>
            <li>
              <FaHackerrank className="stat__list-icon-certificate hack" />
              <a
                href="https://drive.google.com/file/d/1SCv2ieIrKY7VGU2ZPU-jdUrhE1E1AnnX/view?usp=share_link"
                target="_blank"
              >
                Python Skill Assessment, HackerRank <FiExternalLink />
              </a>
            </li>*/}
          </ul>
        </article>
        {/* END OF WEB3 */}
      </div>
    </section>
  );
};

export default Stats;
